// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product {
  background-color: #fff;
  overflow: hidden;
  border-color: #f1f1f1;
  border-width: 1px;
  border-style: solid;
  border-radius: 12px;
  position: relative;
  color: #2d2e49;
}
.product .fav-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 40px;
  border-radius: 50%;
  height: 40px;
  z-index: 33;
}
.product .image img {
  width: 100%;
  height: 280px;
  object-fit: cover;
}
.product .product-info {
  margin-top: 20px;
  padding: 0 20px;
}
.product .product-info h4 {
  font-size: 16px;
}
.product .product-info .price-rate {
  display: flex;
  justify-content: space-between;
  margin: 30px 0 20px;
}
.product .product-info .price-rate span {
  font-size: 20px;
  font-weight: normal;
  font-style: normal;
  color: #2d2e49;
}
.product .product-info .price-rate svg {
  margin-left: 10px;
}

.dark .product {
  background-color: var(--darkSecondColor);
  border-color: var(--darkMaincolor);
  color: var(--darkFont);
}
.dark .product .price-rate span {
  color: var(--darkFont);
}`, "",{"version":3,"sources":["webpack://./src/components/Products/Product/product.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AACF;AAAE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AAEJ;AACI;EACE,WAAA;EACA,aAAA;EACA,iBAAA;AACN;AAEE;EACE,gBAAA;EACA,eAAA;AAAJ;AACI;EACE,eAAA;AACN;AACI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AACN;AAAM;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AAER;AAAM;EACE,iBAAA;AAER;;AAIE;EACE,wCAAA;EACA,kCAAA;EACA,sBAAA;AADJ;AAEI;EACE,sBAAA;AAAN","sourcesContent":[".product {\n  background-color: #fff;\n  overflow: hidden;\n  border-color: #f1f1f1;\n  border-width: 1px;\n  border-style: solid;\n  border-radius: 12px;\n  position: relative;\n  color: #2d2e49;\n  .fav-btn {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    width: 40px;\n    border-radius: 50%;\n    height: 40px;\n    z-index: 33;\n  }\n  .image {\n    img {\n      width: 100%;\n      height: 280px;\n      object-fit: cover;\n    }\n  }\n  .product-info {\n    margin-top: 20px;\n    padding: 0 20px;\n    h4 {\n      font-size: 16px;\n    }\n    .price-rate {\n      display: flex;\n      justify-content: space-between;\n      margin: 30px 0 20px;\n      span {\n        font-size: 20px;\n        font-weight: normal;\n        font-style: normal;\n        color: #2d2e49;\n      }\n      svg {\n        margin-left: 10px;\n      }\n    }\n  }\n}\n.dark {\n  .product {\n    background-color: var(--darkSecondColor);\n    border-color: var(--darkMaincolor);\n    color: var(--darkFont);\n    .price-rate span {\n      color: var(--darkFont);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
